export default __webpack_public_path__ + "static/media/BMSVNCKH-08A ĐXDTHĐT.1f895e92.docx";